import script from "./ConsultationCreatePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultationCreatePopup.vue?vue&type=script&setup=true&lang=js"

import "./ConsultationCreatePopup.vue?vue&type=style&index=0&id=72ee2b48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ee2b48"]])

export default __exports__